import React from 'react';

import { formatIsoDate } from 'utils/dates';

import ApiModeSelection from 'app/models/api_mode_selection';
import DateRange from 'app/models/date_range';
import FulfillmentThirdPartyFailedOrderReport from 'app/models/fulfillment_third_party_failed_order_report';

import Base from 'app/views/base';

import { List as ListView, Heading } from 'app/components/list/list';
import PageHeader from 'app/components/page_header_react';
import RequestReportView from 'app/components/request_report';

import FulfillmentMarketplaceAccounts from 'app/collections/fulfillment_marketplace_accounts';

import tmpl from './template';

const getStatus = (createdAt, disabledAt) => {
  if (createdAt === disabledAt) {
    return 'pending';
  } else if (disabledAt) {
    return 'disabled';
  }
  return 'active';
};

const STATUS_CLASS = {
  disabled: 'muted',
  pending: 'info',
  active: 'success',
};

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'fulfillment_products',

  initialize({ user }) {
    this.apiModeSelection = new ApiModeSelection({});
    this.dateRange = new DateRange({});
    this.user = user;
    this.collection = new FulfillmentMarketplaceAccounts(this.user.get('vendor').third_party_stores);

    this.listenTo(this.user, 'sync', this.render);

    const headings = [
      new Heading({
        property: 'store',
        display: 'Store Name',
        xsSize: 4,
        smSize: 3,
      }),
      new Heading({
        property: 'platform',
        display: 'Platform',
        xsSize: 3,
        smSize: 1,
        wrapperClass: 'text-capitalize',
      }),
      new Heading({
        text: m => formatIsoDate(m.get('created_at')),
        display: 'Created At',
        xsSize: 2,
        smHidden: true,
      }),
      new Heading({
        text: m => formatIsoDate(m.get('start_date')),
        display: 'Order Start Date',
        xsSize: 2,
        smSize: 2,
      }),
      new Heading({
        text: m => {
          const status = getStatus(m.get('created_at'), m.get('disabled_at'));
          return {
            class: `badge badge-${STATUS_CLASS[status]}`,
            text: status,
          };
        },
        display: 'Status',
        xsSize: 2,
        mdSize: 1,
      }),
      new Heading({
        subView: m => new RequestReportView({
          filterId: m.get('id'),
          maxDays: 0,
          ReportClass: FulfillmentThirdPartyFailedOrderReport,
          apiModeSelection: this.apiModeSelection,
          dateRange: this.dateRange,
        }),
        display: 'Failed Orders',
        xsHidden: true,
        smHidden: true,
        mdSize: 3,
      }),
    ];

    this.addReactComponent('header', <PageHeader name="Fulfillment Marketplace Accounts" />);
    this.addSubview('marketplaceAccountsList', '#mpa_list', new ListView({
      headings,
      collection: this.collection,
      user: this.user,
    }));
    this.collection.trigger('update');
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/fulfillment_marketplace_accounts/index.jsx